import React, { useEffect, useState } from "react";
import {
  capitalizeFirstLetter,
  getStatusColor,
  getStatusTextColor,
} from "../../../../utilz/function";
import Input from "../../../../components/input";
import FIlterSelect from "../../../../components/filter-select";
import Table from "../../../../components/table";

interface Variant {
  name: string;
  price: string;
  quantity: string;
  reorderLevel: string;
}

interface TopCustomer {
  customerName: string;
  customerEmail: string;
  totalQuantity: string;
}

interface ProductData {
  _id: string;
  inventoryId: string;
  name: string;
  description: string;
  category: string;
  measurementUnit: string;
  quantity: string;
  reorderLevel: string;
  approvalStatus: string;
  isVariant: boolean;
  variants?: Variant[];
  topCustomers: TopCustomer[];
}

interface InventorySingleTableProps {
  data: ProductData;
  selectedStatus?: string;
  handleStatusChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

const InventorySingleTable: React.FC<InventorySingleTableProps> = ({
  data,
  selectedStatus,
}) => {
  const [filteredData, setFilteredData] = useState<TopCustomer[]>([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedType, setSelectedType] = useState("");

  const columns = [
    { header: "Name", accessor: "customerName" },
    { header: "Email", accessor: "customerEmail" },
    { header: "Quantity", accessor: "totalQuantity" },
  ];

  useEffect(() => {
    if (data?.topCustomers) {
      const filtered = data.topCustomers.filter((customer) => {
        const searchMatch =
          !searchQuery ||
          customer?.customerName?.toLowerCase().includes(searchQuery?.toLowerCase()) ||
          customer?.customerEmail?.toLowerCase().includes(searchQuery?.toLowerCase());
        
        // Add your filtering logic for selectedType if needed
        // const typeMatch = !selectedType || someCondition;
        
        return searchMatch;
      });
      setFilteredData(filtered);
    }
  }, [data, selectedStatus, searchQuery, selectedType]);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };

  const handleCustomerFilterChange = (selectedValue: string) => {
    setSelectedType(selectedValue);
  };

  console.log(data);

  return (
    <div className="py-3 bg-white rounded-3xl shadow border w-full border-[#C9C9C9] pt-5">
      <div className="md:flex justify-between px-5">
        <p className="text-[20px] font-bold">Top Customers</p>
        <div className="md:flex gap-2 items-center md:mt-0 mt-2">
          <Input
            name="search"
            value={searchQuery}
            onChange={handleSearchChange}
            className="w-full"
            placeholder="Search"
            icon="searchIcon"
          />

          <FIlterSelect
            name="category"
            options={[
              { value: "premium", label: "Premium" },
              { value: "gold", label: "Gold" },
            ]}
            className="mt-2 md:-mt-2 w-full md:w-[50%]"
            icon="filterIcon"
            onChange={handleCustomerFilterChange}
            value={selectedType}
          />
        </div>
      </div>

      {data?.topCustomers?.length > 0 ? (
        <Table columns={columns} data={filteredData} selectedUserId={null} />
      ) : (
        <div className="opacity-80 mt-10 text-[14px] font-semibold text-center text-[#4E4E4E] mx-auto">
          This product is pending approval and can not have any customers order
          it
        </div>
      )}
    </div>
  );
};

export default InventorySingleTable;